let audioCtx: AudioContext | null = null

const getAudioContext = () => {
    if (!audioCtx) {
        const AudioContext = window.AudioContext || (window as any).webkitAudioContext
        if (AudioContext) {
            audioCtx = new AudioContext()
        }
    }
    return audioCtx
}

export const unlockAudioContext = () => {
    const ctx = getAudioContext()
    if (!ctx) return

    if (ctx.state === 'suspended') {
        ctx.resume()
    }

    // 播放一个静音 buffer 来彻底解锁 iOS
    const buffer = ctx.createBuffer(1, 1, 22050)
    const source = ctx.createBufferSource()
    source.buffer = buffer
    source.connect(ctx.destination)
    source.start(0)
}

export const playVictorySound = async () => {
    try {
        const ctx = getAudioContext()
        if (!ctx) return

        if (ctx.state === 'suspended') {
            await ctx.resume()
        }

        const t = ctx.currentTime

        // 1. 简单的胜利旋律 (C Major Arpeggio)
        // C5, E5, G5, C6
        const notes = [523.25, 659.25, 783.99, 1046.50]

        notes.forEach((freq, i) => {
            const osc = ctx.createOscillator()
            const gain = ctx.createGain()

            osc.type = 'triangle'
            osc.frequency.setValueAtTime(freq, t + i * 0.1)

            osc.connect(gain)
            gain.connect(ctx.destination)

            const startTime = t + i * 0.1
            osc.start(startTime)

            // Envelope
            gain.gain.setValueAtTime(0, startTime)
            gain.gain.linearRampToValueAtTime(0.3, startTime + 0.05) // Increased volume
            gain.gain.exponentialRampToValueAtTime(0.01, startTime + 0.5)

            osc.stop(startTime + 0.5)
        })

        // 2. 模拟烟花爆炸声 (Filtered Noise)
        const createFirework = (delay: number) => {
            const bufferSize = ctx.sampleRate * 2
            const buffer = ctx.createBuffer(1, bufferSize, ctx.sampleRate)
            const data = buffer.getChannelData(0)

            for (let i = 0; i < bufferSize; i++) {
                data[i] = Math.random() * 2 - 1
            }

            const noise = ctx.createBufferSource()
            noise.buffer = buffer

            const filter = ctx.createBiquadFilter()
            filter.type = 'lowpass'
            filter.frequency.value = 1000

            const gain = ctx.createGain()

            noise.connect(filter)
            filter.connect(gain)
            gain.connect(ctx.destination)

            const startTime = t + delay

            noise.start(startTime)

            // Volume Envelope
            gain.gain.setValueAtTime(0, startTime)
            gain.gain.linearRampToValueAtTime(0.5, startTime + 0.05) // Increased volume
            gain.gain.exponentialRampToValueAtTime(0.01, startTime + 1.2)

            // Filter Envelope (Boom effect)
            filter.frequency.setValueAtTime(800, startTime)
            filter.frequency.exponentialRampToValueAtTime(100, startTime + 0.8)

            noise.stop(startTime + 1.2)
        }

        // 播放三次爆炸声，配合烟花动画
        createFirework(0.2) // First boom
        createFirework(0.5) // Second boom
        createFirework(0.9) // Third boom

    } catch (error) {
        console.warn('Audio playback failed:', error)
    }
}
